import React from 'react';
import styled from 'styled-components';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';

import totusLogo from 'common/images/logo.svg';

import { LoginForm } from './components/loginForm';
import { RecoverForm } from './components/recoverForm';

const BackgroundContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  grid-row-gap: 1rem;
  min-height: 100vh;
  min-width: 100vw;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.menu.background};
`;

const Card = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 3px;
  background-color: ${(props) => props.theme.cardLevel1};
  box-shadow: ${(props) => props.theme.shadows[1]};
  padding: 1rem;
`;

const LogoImage = styled.img`
  width: 10rem;
  margin: 1rem auto;
`;

const Footer = styled.div`
  display: flex;
  margin-top: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const FooterText = styled.p`
  margin: 6px;
`;

const Login = () => {
  const location = useLocation();

  return (
    <BackgroundContainer>
      <Card>
        <LogoImage src={totusLogo} />
        <Switch>
          <Route path="/login" component={LoginForm} />
          <Route path="/forgotPassword" component={RecoverForm} />
          <Route
            render={() => (
              <Redirect
                to={{
                  pathname: '/login',
                  state: { next: `${location.pathname}${location.search}` },
                }}
              />
            )}
          />
        </Switch>
      </Card>
      <Footer>
        <FooterText>&copy; Totus 2021</FooterText>
        <FooterText>enquiries@totusbet.com</FooterText>
      </Footer>
    </BackgroundContainer>
  );
};
export default Login;
